export const UI_CONTROLLER_ADD_LOG = 'UI_CONTROLLER_ADD_LOG';
export const UI_CONTROLLER_ADD_LOG_FAIL = 'UI_CONTROLLER_ADD_LOG_FAIL';
export const UI_CONTROLLER_ADD_LOG_SUCCESS = 'UI_CONTROLLER_ADD_LOG_SUCCESS';
